import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import red from '../../../img/red.png';
import gray from '../../../img/gray.png';
import './NewMenu.css';

const NewMobileMenu = ({ items }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    const index = items.findIndex(item => location.pathname.includes(item.url));
    if (index !== -1) setActiveIndex(index);
  }, [location.pathname, items]); 

  return (
    <div className="mobile-menu-wrapper">
      <div className="mobile-menu-container">
        {items.map((item, index) => ( 
          <img
            key={item.url}
            src={activeIndex === index ? red : gray}
            onClick={() => navigate(item.url)}
            style={{ cursor: 'pointer', margin: '0 4px' }}
          />
        ))}
      </div>
      {/* <div className="mobile-menu-title">
        {items[activeIndex].title}
      </div> */}
    </div>
  );
};

export default NewMobileMenu;
